import React, { useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaShieldAlt, FaUserLock, FaDatabase, FaCookie, FaEnvelope, FaCircle } from 'react-icons/fa';
import { COLORS } from '../constants/colors';

function PrivacyScreen() {
    const copper = COLORS.COPPER;
    const sageGreen = COLORS.SAGE_GREEN;
    const plum = COLORS.PLUM;
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const InfoCard = ({ icon, title, children }) => (
        <Card className="h-100 border-0 shadow-sm hover-shadow">
            <Card.Body className="p-4">
                <div className="text-center mb-4">
                    <div className="rounded-circle bg-light d-inline-flex p-3">
                        {icon}
                    </div>
                </div>
                <Card.Title className="text-center h5 mb-3" style={{ color: plum }}>{title}</Card.Title>
                <Card.Text className="text-muted">
                    {children}
                </Card.Text>
            </Card.Body>
        </Card>
    );

    return (
        <div className="bg-light min-vh-100 py-5">
            <Container>
                {/* Hero Section */}
                <Row className="mb-5">
                    <Col className="text-center">
                        <h1 className="display-4 fw-bold mb-3" style={{ color: plum }}>
                            Privacy Policy
                        </h1>
                        <p className="lead" style={{ color: copper }}>
                            How we protect and manage your personal information
                        </p>
                    </Col>
                </Row>

                {/* Main Content */}
                <Row className="g-4 mb-5">
                    <Col md={6} lg={4}>
                        <InfoCard 
                            icon={<FaShieldAlt size={24} color={sageGreen} />}
                            title="Data Protection"
                        >
                            <ul className="list-unstyled">
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Secure data encryption</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Regular security audits</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Access controls</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Data minimization</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Secure storage</li>
                            </ul>
                        </InfoCard>
                    </Col>

                    <Col md={6} lg={4}>
                        <InfoCard 
                            icon={<FaUserLock size={24} color={sageGreen} />}
                            title="User Rights"
                        >
                            <ul className="list-unstyled">
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Access your data</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Request corrections</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Data portability</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Right to be forgotten</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Object to processing</li>
                            </ul>
                        </InfoCard>
                    </Col>

                    <Col md={6} lg={4}>
                        <InfoCard 
                            icon={<FaDatabase size={24} color={sageGreen} />}
                            title="Data Collection"
                        >
                            <ul className="list-unstyled">
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Account information</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Transaction data</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Usage statistics</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Communication logs</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Device information</li>
                            </ul>
                        </InfoCard>
                    </Col>
                </Row>

                {/* Additional Sections */}
                <Row className="mb-5">
                    <Col className="text-center">
                        <h2 className="h3 fw-bold mb-4" style={{ color: plum }}>
                            Additional Information
                        </h2>
                    </Col>
                </Row>

                <Row className="g-4 mb-5">
                    <Col md={6} lg={4}>
                        <InfoCard 
                            icon={<FaCookie size={24} color={sageGreen} />}
                            title="Cookies & Tracking"
                        >
                            <ul className="list-unstyled">
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Essential cookies</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Analytics cookies</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Preference cookies</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Marketing cookies</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Cookie management</li>
                            </ul>
                        </InfoCard>
                    </Col>

                    <Col md={6} lg={4}>
                        <InfoCard 
                            icon={<FaEnvelope size={24} color={sageGreen} />}
                            title="Communication"
                        >
                            <ul className="list-unstyled">
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Email notifications</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Marketing communications</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Service updates</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Transaction alerts</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Preference settings</li>
                            </ul>
                        </InfoCard>
                    </Col>

                    <Col md={6} lg={4}>
                        <InfoCard 
                            icon={<FaShieldAlt size={24} color={sageGreen} />}
                            title="Third Parties"
                        >
                            <ul className="list-unstyled">
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Payment processors</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Analytics providers</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Cloud services</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Security partners</li>
                                <li className="mb-2"><FaCircle size={8} className="me-2" style={{ color: sageGreen }} /> Data processors</li>
                            </ul>
                        </InfoCard>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default PrivacyScreen; 